import { render, staticRenderFns } from "./ClientAreasList.vue?vue&type=template&id=b85be6da"
import script from "./ClientAreasList.vue?vue&type=script&lang=js"
export * from "./ClientAreasList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports